<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1 8H15"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
